<template>
 <div class='container flavor-container'>
     <div class="title-bar"></div>
    <h2>Flavors</h2>
    <div class="row center-block" id="flavor-images">
            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" v-for="flavor of flavorsFiles" :key="flavor.id">
                <div class="hovereffect" onclick="">
                    <img class="img-fluid" :src="flavor.primary.flavor_image.url" >
                    <div class="overlay">
                        <h2>{{flavor.primary.flavor_title[0].text}}</h2>
                        <span class="info">{{flavor.primary.flavor_description[0].text}}</span>
                    </div>
                </div>
            </div>    
    </div>
</div>
</template>
<script>
import $ from "jquery"
export default {
    name: "Flavors",
    data() {
        return {
            flavorsFiles: null
        }
    },
    methods: {
          getContent (uid) {
        this.$prismic.client.getByUID('flavors', uid)
          .then((document) => {
            if (document) {
              console.log(document.data);
              this.flavorsFiles = document.data.body
            } else {
              this.$router.push({ name: 'not-found' })
            }
          })
      }
    },
    created () {
        this.getContent('flavor-page');
      
    }
}

</script>
<style lang="scss">
.flavor-container {
    margin-top: 75px;
    h2 {
        font-family: "lust-script",sans-serif;
        font-size: 3em;
        color: #300B02;
    }
    .col-lg-4, .col-md-4, .col-sm-6, .col-xs-12 {
        padding-left: 0px;
        padding-right: 0px;
    }
}
/*Flavor image hover effects*/
.hovereffect {
    width:100%;
    float:left;
    overflow:hidden;
    position:relative;
    text-align:center;
    cursor:default;

    h2 {
        font-family: "raleway",sans-serif;
    }

}

.hovereffect .overlay {
width:100%;
height:100%;
position:absolute;
overflow:hidden;
top:0;
left:0;
opacity:0;
background-color:rgba(0,0,0,0.5);
-webkit-transition:all .4s ease-in-out;
transition:all .4s ease-in-out
}

.hovereffect img {
display:block;
position:relative;
-webkit-transition:all .4s linear;
transition:all .4s linear;

}

.hovereffect h2 {
text-transform:uppercase;
color:#fff;
text-align:center;
position:relative;
font-size:17px;
background:rgba(0,0,0,0.6);
-webkit-transform:translatey(-100px);
-ms-transform:translatey(-100px);
transform:translatey(-100px);
-webkit-transition:all .2s ease-in-out;
transition:all .2s ease-in-out;
padding:10px;
}

.hovereffect .info {
text-decoration:none;
display:inline-block;
text-transform:uppercase;
color:#fff;
border:1px solid #fff;
background-color:transparent;
opacity:0;
filter:alpha(opacity=0);
-webkit-transition:all .2s ease-in-out;
transition:all .2s ease-in-out;
margin:10px 0 0;
padding:7px 14px;
font-size: smaller;
}

.hovereffect .info:hover, .hovereffect .info:focus {
box-shadow:0 0 5px #fff;
}

.hovereffect:hover img, .hovereffect:focus img {
-ms-transform:scale(1.2);
-webkit-transform:scale(1.2);
transform:scale(1.2);
}

.hovereffect:hover .overlay, .hovereffect:focus .overlay {
opacity:1;
filter:alpha(opacity=100);
}

.hovereffect:hover h2,.hovereffect:hover .info, .hovereffect:focus h2, .hovereffect:focus .info {
opacity:1;
filter:alpha(opacity=100);
-ms-transform:translatey(0);
-webkit-transform:translatey(0);
transform:translatey(0);
}

.hovereffect:hover .info, .hovereffect:focus .info {
-webkit-transition-delay:.2s;
transition-delay:.2s;
}
</style>